import DefaultSettings from '@advisor/models/store/settings/default';
// eslint-disable-next-line import/no-cycle
import RiaSettings from '@advisor/models/store/settings/common/ria';
import EnterpriseSettings from '@advisor/models/store/settings/common/enterprise';
import FooterSettings from '@advisor/models/store/settings/common/footer';
import quickAccessButton from '@advisor/static/quickAccessButton';

export default class Settings {
  constructor() {
    this.ria = new RiaSettings();
    this.enterprise = new EnterpriseSettings();
    this.footer = new FooterSettings();
    this.default = new DefaultSettings();
  }

  // eslint-disable-next-line class-methods-use-this
  getAllDeps(store) {
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve) => {
      Promise.all([
        // first tier deps
        store.dispatch('settings/getPlatformAccess'),
        store.dispatch('settings/getAdvisorFilter'),
      ]).then(() => {
        Promise.all([
          // store.dispatch('settings/activeSection', false),
          // second tier
          store.dispatch('settings/setQuickAccessButton', quickAccessButton),
        ]).then(resolve);
      });
    });
  }
}
